import { ChangeDetectorRef, Component, OnDestroy, Optional } from '@angular/core';
import { NotificationServiceJsVersStatutWebsocketService } from './notification-service-js-vers-statut-websocket.service';
import { Subscription } from 'rxjs';
import { StatutWebsocketDto } from './statut-websocket-dto.model';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AbstractSigaleComponent } from '../abstract-sigale.component';
import { NotifierService } from '../../services/notifier.service';
import { StompService } from '../../services/stomp/stomp.service';
import { RxStompState } from '@stomp/rx-stomp/esm6/rx-stomp-state';

@Component({
	standalone: true,
	selector: 'statut-websocket-component',
	templateUrl: 'statut-websocket.component.html',
	styleUrls: ['./statut-websocket.component.scss'],
	imports: [
		CommonModule,
		FormsModule,
		TranslateModule
	],
	providers: [
		DatePipe
	]
})
export class StatutWebsocketComponent extends AbstractSigaleComponent implements OnDestroy {

	private statutWebsocket: StatutWebsocketDto;
	private notificationStatutWebsocketSubjectSubscription: Subscription;
	private connectionStateAbonnement: Subscription;

	constructor(private datePipe: DatePipe,
				private notificationServiceJsVersStatutWebsocketService: NotificationServiceJsVersStatutWebsocketService,
				@Optional() private notifierService: NotifierService, @Optional() private stompService: StompService,
				private changeDetectorRef: ChangeDetectorRef) {
		super();
	}

	ngOnInit() {
		super.ngOnInit();
		if (this.stompService) {
			this.connectionStateAbonnement = this.stompService.connectionState$.subscribe(state => {
				console.log('Connection State ' + state);
				this.statutWebsocket = new StatutWebsocketDto(state === RxStompState.OPEN, Date.now());
				// On force le rechargement parce que la connexion avec les websockets se fait en dehors du contexte angular, donc à la réception de cette notification,
				// le composant ne se met pas à jour tout seul
				this.changeDetectorRef.detectChanges();
			});
		}
		else if (this.notifierService) {
			this.statutWebsocket = new StatutWebsocketDto(this.notifierService.connected, Date.now());
			this.notificationStatutWebsocketSubjectSubscription = this.notificationServiceJsVersStatutWebsocketService.notificationStatutWebsocketSubject.subscribe((statutWebsocket: StatutWebsocketDto) => {
				if (!this.statutWebsocket || this.statutWebsocket.estConnectee || statutWebsocket.estConnectee) {
					this.statutWebsocket = statutWebsocket;
					// On force le rechargement parce que la connexion avec les websockets se fait en dehors du contexte angular, donc à la réception de cette notification,
					// le composant ne se met pas à jour tout seul
					this.changeDetectorRef.detectChanges();
				}
			});
		}
	}

	ngOnDestroy(): void {
		if (this.stompService) {
			this.stompService.desabonner(this.connectionStateAbonnement);
		}
		else if (this.notificationStatutWebsocketSubjectSubscription) {
			this.notificationStatutWebsocketSubjectSubscription.unsubscribe();
		}
	}

	classPastille(): string {
		return this.estWebsocketConnectee() ? 'pastille-connectee' : 'pastille-deconnectee';
	}

	tooltipPastille(): string {
		if (this.statutWebsocket && this.statutWebsocket.heureDerniereConnexionOuDeconnexion) {
			const messageTooltip = this.estWebsocketConnectee() ? 'SIGALE_ANGULAR.COMPONENTS.STATUT_WEBSOCKET.CONNECTEE_DEPUIS' : 'SIGALE_ANGULAR.COMPONENTS.STATUT_WEBSOCKET.DECONNECTEE_DEPUIS';
			return this.translateService.instant(messageTooltip, { heure: this.datePipe.transform(this.statutWebsocket.heureDerniereConnexionOuDeconnexion, 'HH:mm') });
		}
		return '';
	}

	estWebsocketConnectee(): boolean {
		return this.statutWebsocket && this.statutWebsocket.estConnectee;
	}

	traductionFR(): any {
		return {
			"SIGALE_ANGULAR": {
				"COMPONENTS": {
					"STATUT_WEBSOCKET": {
						"CONNECTEE_DEPUIS": "Websocket connectée depuis {{heure}}",
						"DECONNECTEE_DEPUIS": "Websocket deconnectée depuis {{heure}}"
					}
				}
			}
		};
	}


	traductionIT(): any {
		return {
			"SIGALE_ANGULAR": {
				"COMPONENTS": {
					"STATUT_WEBSOCKET": {
						"CONNECTEE_DEPUIS": "Websocket connessa da {{heure}}",
						"DECONNECTEE_DEPUIS": "Websocket disconnessa da {{heure}}"
					}
				}
			}
		};
	}
}
